import Vue from "vue";
import store from "@/store";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Onboarding from "@/views/Onboarding.vue";
import NHome from "@/views/NHome.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    meta: { requiresAuth: true },
    component: Home
  },
  {
    path: "/canary",
    name: "Canary",
    meta: { requiresAuth: true },
    component: NHome
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    component: Onboarding
  },
  { path: "/autosetup", redirect: "/onboarding" },
  {
    path: "/settings",
    name: "Settings",
    meta: { requiresAuth: true },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "settings" */ "@/views/Settings")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next("/");
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.state.appconfig.showOnboarding) {
      next({
        path: "/onboarding",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else if (
    to.name === "Onboarding" &&
    !store.state.appconfig.showOnboarding
  ) {
    next({
      path: "/"
    });
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
